export default "__VITE_ASSET__612af16d__"